import { render } from "./TempuraView.vue?vue&type=template&id=66a6d27d"
import script from "./TempuraView.vue?vue&type=script&lang=js"
export * from "./TempuraView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__